export default __webpack_public_path__ + "static/media/groups-striker.7d0ef14e.svg";